<template>
  <master-page>
    <br/>
    <v-card>
      <v-card-title>
        <v-icon large left>mdi-cash-minus</v-icon>
        <span class="title font-weight-light">Compromisso</span>
        <v-spacer/>
          
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Novo()">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Novo Compromisso</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Imprimir()">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Atualizar()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Atualizar</span>
          </v-tooltip>

        <v-expansion-panels focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>Filtros</v-expansion-panel-header>
            <v-expansion-panel-content class="mt-5">
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete v-model="filtro.fornecedorId" :items="fornecedores" :loading="isFornecedorLoading" :search-input.sync="searchFornecedor" hide-no-data hide-selected cache-items clearable
                    item-text="cpfCnpjNome" item-value="id" label="Fornecedor" placeholder="Digite um fornecedor" dense outlined/>
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected cache-items clearable
                    item-text="codigoNome" item-value="id" label="Projeto" placeholder="Digite um projeto" dense outlined/>
                </v-col>
              </v-row>
              <v-row align="center">
                
                <!-- DATA VENCIMENTO -->
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.vencimentoInicial" label="Vencimento Inicial" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.vencimentoInicial" no-title/>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="1">
                  <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                </v-col>
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.vencimentoFinal" label="Vencimento Final" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.vencimentoFinal" no-title/>
                  </v-menu>
                </v-col>
                
                <v-col cols="12" md="2"/>
                
                <!-- DATA PAGAMENTO -->
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.pagamentoInicial" label="Pagamento Inicial" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.pagamentoInicial" no-title/>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="1">
                  <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                </v-col>
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.pagamentoFinal" label="Pagamento Final" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.pagamentoFinal" no-title/>
                  </v-menu>
                </v-col>
                
                <!-- EMISSAO -->
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.emissaoInicial" label="Emissão Inicial" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.emissaoInicial" no-title/>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="1">
                  <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                </v-col>
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.emissaoFinal" label="Emissão Final" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.emissaoFinal" no-title/>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="2"/>

                <!-- COMPETENCIA -->
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.competenciaInicial" label="Competência Inicial" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.competenciaInicial" no-title/>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="1">
                  <span style="font-size: 18px; display: flex; justify-content: center; align-items: center; margin-top: -25px">até</span>
                </v-col>
                <v-col cols="12" md="2">
                  <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                    <template v-slot:activator="{on}">
                      <v-text-field type="date" v-model="filtro.competenciaFinal" label="Competência Final" dense outlined>
                        <template v-slot:prepend>
                          <v-icon v-on="on">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker locale="pt-br" v-model="filtro.competenciaFinal" no-title/>
                  </v-menu>
                </v-col>

              </v-row>
              <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field v-model="filtro.numeroDocumento" label="Número Documento" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-select v-model="filtro.situacao" label="Situação" :items="situacoes" item-value="key" item-text="value" dense outlined/>
                  </v-col>
                  <v-col cols="12" md="6" style="display: flex" class="pa-0">
                    <v-row class="pa-0" style="display: flex; align-items: flex-start; justify-content: center">
                      <v-col cols="12" sm="4" md="5">
                        <v-text-field label="Código (Inicio)" v-model="filtro.codigoInicio" dense outlined hide-details/>
                      </v-col>
                      <v-col cols="12" md="1">
                        <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                      </v-col>
                      <v-col cols="12" sm="4" md="5">
                        <v-text-field label="Código (Fim)" v-model="filtro.codigoFim" dense outlined hide-details/>
                      </v-col>
                    </v-row>
                  </v-col>
              </v-row>
              <v-row class="mt-3">
                <v-spacer/>
                <v-btn color="accent" @click="Atualizar()">Consultar</v-btn>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-title>

      <v-card-text>

        <v-data-table id="tabela" :headers="headers" :items="lista" :options.sync="options" :server-items-length="totalLista" :loading="loading" class="elevation-1">
    
          <template v-slot:[`item.actions`]="{ item }">

            <v-tooltip right v-if="item.situacao !== 'C' && item.situacao !== 'P'">
              <template v-slot:activator="{ on }">
                <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip right v-if="item.situacao !== 'C' && item.situacao !== 'P'">
              <template v-slot:activator="{ on }">
                <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>

            <v-tooltip right v-if="item.situacao === 'A'">
              <template v-slot:activator="{ on }">
                <v-icon small @click="Cancelar(item)" v-on="on">mdi-close-circle</v-icon>
              </template>
              <span>Cancelar</span>
            </v-tooltip> 

            <v-tooltip right v-if="PermissaoRestrita('QuitacaoCompromisso')">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" color="blue-grey lighten-1">mdi-chevron-down-circle</v-icon>
              </template>
              <span>Baixar</span> <br/>
              <span>Restrito ao seu usuário ou plano.</span>
            </v-tooltip>   

            <v-tooltip right v-else-if="item.situacao === 'A'">
              <template v-slot:activator="{ on }">
                <v-icon small @click="Baixar(item)" v-on="on">mdi-chevron-down-circle</v-icon>
              </template>
              <span>Baixar</span>
            </v-tooltip>

            <v-tooltip right v-if="item.situacao === 'P'">
              <template v-slot:activator="{ on }">
                <v-icon small @click="Reabrir(item)" v-on="on">mdi-lock-open</v-icon>
              </template>
              <span>Reabrir</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-icon small @click="Consultar(item)" v-on="on">mdi-binoculars</v-icon>
              </template>
              <span>Consultar</span>
            </v-tooltip>

            <v-tooltip right v-if="item.nomeComprovante">
              <template v-slot:activator="{ on }">
                <v-icon small @click="DownloadComprovante(item)" v-on="on">mdi-download</v-icon>
              </template>
              <span>Comprovante</span>
            </v-tooltip>

          </template>

          <template v-slot:[`item.situacao`]="{ item }">
            <v-chip :style=" item.situacao === 'A' ? 'background: var(--v-chipYellow-base) !important' : item.situacao === 'P' ? 'background: var(--v-chipGreen-base) !important' : 'background: var(--v-chipRed-base) !important'">
              <span style="font-weight: bold" :style=" item.situacao === 'A' ? 'color: var(--v-chipFontYellow-base) !important' : item.situacao === 'P' ? 'color: var(--v-chipFontGreen-base) !important' : 'color: var(--v-chipFontRed-base) !important'">
                {{item.situacao === "A" ? "Aberto" : item.situacao === "P" ? "Pago" : "Cancelado"}}
              </span>
            </v-chip>
          </template>

          <template v-slot:[`item.dataVencimento`]="{ item }">
            {{new Date(item.dataVencimento).ddmmyyyy()}}
          </template>

          <template v-slot:[`item.dataPagamento`]="{ item }">
            {{ item.dataPagamento ? new Date(item.dataPagamento).ddmmyyyy() : ''}}
          </template>

          <template v-slot:[`item.valor`]="{ item }">
            {{item.valor.toMoeda()}}
          </template>

          <template v-slot:[`item.desconto`]="{ item }">
            {{item.desconto.toMoeda()}}
          </template>

          <template v-slot:[`item.juros`]="{ item }">
            {{item.juros.toMoeda()}}
          </template>

          <template v-slot:[`item.valorFinal`]="{ item }">
            {{item.valorFinal.toMoeda()}}
          </template>

          <template v-slot:[`item.atividadeId`]="{ item }">
            {{ item.atividadeId ? ConsultarAtividade(item) : '' }}
          </template>

          <template v-slot:[`item.atividadeItemId`]="{ item }">
            {{ item.atividadeItemId ? ConsultarAtividadeItem(item) : '' }}
          </template>

        </v-data-table>
      </v-card-text>
        
    </v-card>
    
    <v-overlay :value="primeiraCarga">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    
    <cadastro-compromisso v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Atualizar()" :baixa="baixa"/>
  
  </master-page>
</template>

<script>
import CompromissoService from '@/core/services/financeiro/CompromissoService';
import Compromisso from '@/core/domain/financeiro/Compromisso';
import FornecedorService from '@/core/services/financeiro/FornecedorService';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import SituacaoFormaPagamentoService from '@/core/services/financeiro/SituacaoFormaPagamentoService';
import UsuarioService from '../../../core/services/geral/UsuarioService';

export default {
  data() {
    return {
      service: new CompromissoService(),
      item: new Compromisso(),
      baixa: false,
      totalLista: 0,
      lista: [],
      dialogCadastro: false,
      loading: true,
      options: {
        itemsPerPage: 15
      },
      headers: [
        { text: '', value:'actions', sortable: false  },
        { text: 'Código', value: 'id', type: 'number' },
        { text: 'Fornecedor', value: 'fornecedor.nome' },
        { text: 'Sit.', value: 'situacao' },
        { text: 'Vencimento', value: 'dataVencimento', type: 'date' },
        { text: 'Pagamento', value: 'dataPagamento', type: 'date' },
        { text: 'Valor', value: 'valor', type: 'number' },
        { text: 'Desc,', value: 'desconto', type: 'number' },
        { text: 'Juros', value: 'juros', type: 'number' },
        { text: 'Total', value: 'valorFinal', type: 'number' },
        { text: 'Projeto', value: 'projetoId', type: 'number' },
        { text: 'Atividade', value: 'atividadeId', type: 'number' },
        { text: 'Sub Atividade', value: 'atividadeItemId', type: 'number' },
        { text: 'Descrição', value: 'descricao'}
      ],
      search: '',
      isFornecedorLoading: false,
      isProjetoLoading: false,
      situacoes: [],
      fornecedores: [],
      projetos: [],
      searchFornecedor: null,
      searchProjeto: null,
      filtro: {
        fornecedorId: null,
        projetoId: null,
        numeroDocumento: '',
        vencimentoInicial: '',
        vencimentoFinal: '',
        pagamentoInicial: '',
        pagamentoFinal: '',
        emissaoInicial: '',
        emissaoFinal: '',
        competenciaInicial: '',
        competenciaFinal: '',
        situacao: 'A',
        codigoInicio: null,
        codigoFim: null
      },
      permissoes: [],
      primeiraCarga: true,
      tipoUsuario: '',
      loadingDownload: false
    }
  },
  watch: {
    options: {
      handler () {
        this.Atualizar();
      },
      deep: true
    },
    searchFornecedor (val) {
      if (this.isFornecedorLoading) return;
      if (!val) return;
      
      this.isFornecedorLoading = true
      let fornecedorService = new FornecedorService();
      fornecedorService.AutoComplete(val)
        .then(
          res => {
            this.fornecedores = res.data;
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        .finally(() => (this.isFornecedorLoading = false))
    },
    searchProjeto (val) {
      if (this.isProjetoLoading) return;
      if (!val) return;
      
      this.isProjetoLoading = true
      let projetoService = new ProjetoService();
      projetoService.AutoComplete(val)
        .then(
          res => {
            this.projetos = res.data;
          },
          err => this.$swal('Aviso', err.response.data, 'error')
        )
        .finally(() => (this.isProjetoLoading = false))
    },
    lista: function(){
      if(this.primeiraCarga)
        this.primeiraCarga = false;
    }
  },
  methods: {
    Novo(){
      this.item = new Compromisso()
      this.dialogCadastro = true;
      this.baixa = false;
    },
    Atualizar(){
        this.loading = true;
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        this.service.ListarComFiltro(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, this.filtro, "Fornecedor, Projeto.Atividades.Itens").then(
          res => {
            this.lista = res.data.items; 
            this.totalLista = res.data.count;
            this.loading = false;
          },
          err => {
            this.loading = false;
            this.$swal('Aviso', err.response.data, 'error')
          }
        );
    },
    Editar(item){
      this.service.ObterPorId(item.id, "Fornecedor, Projeto.Atividades.Itens").then(
        res =>{
          this.item = Object.assign({}, new Compromisso(res.data))
          this.dialogCadastro = true;
          this.baixa = false;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      )
    },
    Excluir(item) {
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja excluir o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.service.Excluir(item.id)
            .then(res => {
              if (res.status == 200){
                return res;
              }
            }, 
            err => this.$swal('Aviso', err.response.data, 'error'))
          },
        allowOutsideClick: () => !this.$swal.isLoading()
        })
        .then((result) => {
            if(result.value) {
                this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                this.Atualizar();
            }
        })

    },
    Imprimir(){
      let routeLink = this.$router.resolve({ name: 'imprimeCompromisso', 
        query: { 
          fornecedorId: this.filtro.fornecedorId,
          projetoId: this.filtro.projetoId,
          vencimentoInicial: this.filtro.vencimentoInicial,
          vencimentoFinal: this.filtro.vencimentoFinal,
          pagamentoInicial: this.filtro.pagamentoInicial,
          pagamentoFinal: this.filtro.pagamentoFinal,
          emissaoInicial: this.filtro.emissaoInicial,
          emissaoFinal: this.filtro.emissaoFinal,
          competenciaInicial: this.filtro.competenciaInicial,
          competenciaFinal: this.filtro.competenciaFinal,
          situacao: this.filtro.situacao,
          codigoInicio: this.filtro.codigoInicio,
          codigoFim: this.filtro.codigoFim
        } 
      });

      window.open(routeLink.href, '_blank');
    },
    Baixar(item){
      this.service.ObterPorId(item.id, "Fornecedor, Projeto.Atividades.Itens").then(
        res =>{
          this.item = Object.assign({}, new Compromisso(res.data))
          this.dialogCadastro = true;
          this.baixa = true;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      )
      // this.item = Object.assign({}, new Compromisso(item))
      // this.dialogCadastro = true;
      // this.baixa = true;
    },
    Cancelar(item) {
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja cancelar o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
            return this.service.Cancelar(item.id)
                    .then(res => {
                        if (res.status == 200){
                            return res;
                        }
                    }, 
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
            },
        allowOutsideClick: () => !this.$swal.isLoading()
        })
        .then((result) => {
            if(result.value) {
                this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                this.Atualizar();
            }
        })

    },
    Reabrir(item) {
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja Reabrir o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
            return this.service.Reabrir(item.id)
                    .then(res => {
                        if (res.status == 200){
                            return res;
                        }
                    }, 
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
            },
        allowOutsideClick: () => !this.$swal.isLoading()
        })
        .then((result) => {
            if(result.value) {
                this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                this.Atualizar();
            }
        })

    },
    PermissaoRestrita(permissao){
      if(this.tipoUsuario == "MASTER" || this.tipoUsuario == "GESTOR"){
        return false;
      }
      else{
        if(this.permissoes.find(x => x.menu == permissao)){
          return false;
        }
        else{
          return true;
        }
      }      
    },
    Consultar(item){
      let routeLink = this.$router.resolve({ name: 'detalharCompromisso', params: { id: item.id.toString() } });
      window.open(routeLink.href, '_blank');
    },
    ConsultarAtividade(item){
      return item.projeto.atividades.find(x => x.id == item.atividadeId).nome;
    },
    ConsultarAtividadeItem(item){
      return item.projeto.atividades.find(x => x.id == item.atividadeId).itens.find(x => x.id == item.atividadeItemId).nome;
    },
    DownloadComprovante(item){
      this.loadingDownload = true;
      this.service.DownloadDocumento(item.id, item.nomeComprovante).then(
        res=> {

        },
        err => {
          this.$swal('Aviso', err.message, 'error');
        }
      ).finally(() => {
        this.loadingDownload = false;
      })
    }
  },
  created(){
    this.sessionApp = JSON.parse(localStorage.sessionApp);

    const usuarioService = new UsuarioService();
    usuarioService.ListarTudo("Permissoes").then(
      res=>{
        var usuario = res.data.items;
        usuario = usuario.find(x => x.id == this.sessionApp.usuarioId)
        this.permissoes = usuario.permissoes;
      }
    )

  },
  mounted() {

    this.sessionApp = JSON.parse(localStorage.sessionApp);
    this.tipoUsuario = this.sessionApp.usuarioNome;

    let situacaoFormaPagamentoService = new SituacaoFormaPagamentoService();
    situacaoFormaPagamentoService.Listar()
      .then(
        res => {
          this.situacoes = res.data;
          this.situacoes.unshift({
            key: null,
            value: 'TODOS'
          });
        },
        err => {
          this.$swal('Aviso', err.message, 'error');
        }
      );
  }
}
</script>
